export const lgpdAdsOwsOptionsFeatureType = 36;
export default lgpdAdsOwsOptionsFeatureType;
